import { useEffect, useState } from 'react';
import { socket } from '../socket';
import api from '../services/api';
import toast from 'react-hot-toast';

export default function useNotifications() {
  const [unread, setUnread] = useState(0);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
      try {
        const res = await api.get('/notifications');
        if (!mounted) return;
        const data = res.data?.data || [];
        setNotifications(data);
        setUnread(data.filter((n) => !n.is_read).length);
      } catch (err) {
        console.error('Failed to fetch notifications', err);
      }
    };

    init();

    const handle = (n) => {
      toast.success(`${n.title}: ${n.message}`);
      setNotifications((prev) => [n, ...prev]);
      setUnread((s) => s + 1);
    };

    socket.on('notification', handle);

    return () => {
      mounted = false;
      socket.off('notification', handle);
    };
  }, []);

  const markAllRead = async () => {
    try {
      await api.put('/notifications/read-all');
      setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
      setUnread(0);
    } catch (err) {
      console.error('Failed to mark all read', err);
    }
  };

  const markAsRead = async (id) => {
    try {
      await api.put(`/notifications/${id}/read`);
      setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, is_read: true } : n)));
      setUnread((s) => Math.max(0, s - 1));
    } catch (err) {
      console.error('Failed to mark as read', err);
    }
  };

  return { unread, notifications, markAllRead, markAsRead };
}
